import { Button, UIHeading1, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OneTwoTripBanner.css';

type TOneTwoTripBannerProps = {
  onClick(): void;
  url: string;
};

export const OneTwoTripBanner: React.VFC<TOneTwoTripBannerProps> = ({ onClick, url }) => {
  const clickHandler = () => {
    onClick();

    // тут намеренно так, а не ссылка, потому что нам нужна статистика кликов, а ссылкой
    // можно потерять клики средней и правой кнопкой мыши, копирование ссылки.
    window.open(url, '_blank');
  };

  return (
    <div className={styles['container']} onClick={clickHandler}>
      <div className={styles['text']}>
        <UIHeading1 color="white_100">Ищите жилье в любой точке мира</UIHeading1>
        <UIHeading4 color="white_100">
          Бронируйте отели, хостелы, апаратементы, дома
          <br />и оплачивайте российской банковской картой на OneTwoTrip
        </UIHeading4>
      </div>
      <Button theme="fill_white_primary">Найти жильё</Button>
    </div>
  );
};
